module.exports = __webpack_public_path__ + "img/08.9ebb07ec.webp";